export const documentApi = {
    heading:[
        {
            head:"SL"
        },
        {
            head:"Document Type"
        },
        {
            head:"Session"
        },
        {
            head:"Class"
        },
        {
            head:"Section"
        },
        {
            head:"Shift"
        },
        {
            head:"Subject"
        },
        {
            head:"Upload Date"
        },
        {
            head:"Activation Date"
        },
        {
            head:"Action"
        },
        {
            head:"Action"
        },
    ],

    data:[
        {
            sl:1165,
            documenttype:"HOME WORK",
            session:"2022-2023",
            class:"7",
            section: "Diamond 1",
            shift:"Morning",
            subject:"Math 101",
            uploadDate:"",
            activationDate:"",
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png",
            delete:"./assets/images/dashboards/adminDashboard/flexvalue/tabledeleteicon.png"
        },
       
    ]
    
    
}